(() => {
  const reveal = () => {
    if (typeof window.Shopify?.tinycookie?.loadPreferences !== 'function') return;
    document.querySelectorAll('[data-gg-cookie-preferences]').forEach((button) => {
      button.hidden = false;
      if (button.dataset.ggCookieReady) return;
      button.dataset.ggCookieReady = 'true';
      button.addEventListener('click', () => {
        if (!document.getElementById('tinycookie-preferences-wrapper')) {
          window.Shopify.tinycookie.loadPreferences();
        }
      });
    });
  };
  reveal();
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
  document.addEventListener('shopify:section:load', reveal);
})();
